import { render, staticRenderFns } from "./Reporteador.vue?vue&type=template&id=2bc52387&"
import script from "./Reporteador.vue?vue&type=script&lang=js&"
export * from "./Reporteador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports